import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Button, Tab, Nav, Image, Modal } from "react-bootstrap";

import step1 from "../../assets/images/Step1.jpg";
import step2 from "../../assets/images/Step2.jpg";
import step3 from "../../assets/images/Step3.png";
import step4 from "../../assets/images/Step4.jpg";

import bg2 from "../../assets/images/wedding4.jpg";
import bg3 from "../../assets/images/party2.png";
import bg4 from "../../assets/images/corporate2.png";
import heroVideo from "../../assets/images/loop-optimized.webm";
import profileImage from "../../assets/images/profile.png";

import ContactUs from "../../components/ContactUs";
import { fetchCompany, fetchPricing } from "../../lib/api";
import { CompanyData, PricingData } from "../../type/PricingData";

const PURCHASE_APP_URL =
  process.env.REACT_APP_PUBLIC_APP_URL ||
  "https://app.theendlessmoment.com";

const getFeatureName = (feature: PricingData["features"][number]) =>
  typeof feature === "string" ? feature : feature.name;

const getPurchaseUrl = () => `${PURCHASE_APP_URL}/auth/signup`;


const Section = () => {
  const [pricingData, setPricingData] = useState<PricingData[]>([]);
  const [companyData, setCompanyData] = useState<CompanyData>();
  const [showVideo, setShowVideo] = useState(false);

  const oneTimePlans = useMemo(
    () =>
      pricingData.filter(
        (plan) =>
          plan.purchase_type === "one_time" ||
          ["Basic", "Essential"].includes(plan.name),
      ),
    [pricingData],
  );

  const corporatePlans = useMemo(
    () =>
      pricingData.filter(
        (plan) =>
          plan.purchase_type === "subscription" ||
          plan.name.toLowerCase().startsWith("corporate"),
      ),
    [pricingData],
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [pricingResponse, companyResponse] = await Promise.all([
          fetchPricing(),
          fetchCompany(),
        ]);

        setPricingData(
          pricingResponse?.filter((plan) => plan.trial_package === false),
        );
        setCompanyData(companyResponse);
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, []);

  return (
    <React.Fragment>
      <section className="section business-home py-10" id="home">
        <div className="home-center padding-bottom-100">
          <div className="business-home-left">
            <div className="business-home-content text-center text-primary">
              {/* <h1 className="business-home-main letter-spacing_2">
                THE ENDLESS MOMENT
              </h1>
              <p className="business-home-desc f-15 text-primary">
                "Preserving Moments, Celebrating Memories—Forever."
              </p> */}
              <h1 className="business-home-subtitle letter-spacing_2">
                Easily Collect Guest Photos, Videos & Notes for Your Special
                Occasion
              </h1>
              <p className="business-home-desc f-15 text-primary">
                Let your guests be part of the story by sharing photos, videos,
                and heartfelt notes through a simple QR code. Watch their
                memories appear instantly on a beautiful live display while
                building your digital gallery and guestbook.
              </p>

              <p className="business-home-desc f-15 text-primary">
                No app required – your guests can instantly share their moments
                directly from any device.
              </p>
              <video
                className="business-home-video business-home-video--mobile"
                src={heroVideo}
                autoPlay
                muted
                loop
                playsInline
                aria-label="The Endless Moment mobile website preview"
              />
              <div className="mt-4 pt-3 mouse-down">           
                <Button href="#packages" className="btn btn-md btn-custom">
                  Purchase Now
                </Button>
                {/* <Button href="#contactus" className="btn btn-md btn-custom">
                  Contact Us
                </Button> */}
                <Button
                  onClick={() => setShowVideo(true)}
                  className="btn btn-md btn-custom"
                >
                  ▶ Watch How It Works
                </Button>
              </div>
            </div>
          </div>
          <div className="business-home-right">
            <video
              className="business-home-video business-home-video--desktop"
              src={heroVideo}
              autoPlay
              muted
              loop
              playsInline
              aria-label="The Endless Moment website preview"
            />
          </div>
        </div>
      </section>
      <hr />
      <section className="section interior-services py-10" id="events">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="text-center">
                <h2 className="heading-title-title letter-spacing_4 text-uppercase">
                  EVENTS
                </h2>
                <hr
                  style={{
                    width: "130px",
                    margin: "auto",
                    marginTop: "20px",
                    borderTop: "1px solid #533C2B",
                    opacity: 1,
                  }}
                />
                <p className="heading-title-desc text-muted mt-4">
                  Cherish Every Event, Capture Every Memory <br />
                  Perfect for Weddings, Parties, Corporate Events, and More!
                </p>
              </div>
            </Col>
          </Row>

          <Row className="mt-5 pt-4">
            <Col lg={12}>
              <Tab.Container id="pills-tab" defaultActiveKey="#planning">
                <Nav className="nav nav-tabs nav-pills mb-3" role="tablist">
                  <Col sm={4} xs={6}>
                    <Nav.Item>
                      <Nav.Link eventKey="#planning">
                        <div className="interior-services-icon">
                          <i className="pe-7s-date"></i>
                        </div>
                        <h5 className="mb-0 text-uppercase f-15 letter-spacing_2 mt-3">
                          WEDDING
                        </h5>
                      </Nav.Link>
                    </Nav.Item>
                  </Col>
                  <Col sm={4} xs={6}>
                    <Nav.Item>
                      <Nav.Link eventKey="#interior">
                        <div className="interior-services-icon">
                          <i className="pe-7s-star"></i>
                        </div>
                        <h5 className="mb-0 text-uppercase f-15 letter-spacing_2 mt-3">
                          PARTIES
                        </h5>
                      </Nav.Link>
                    </Nav.Item>
                  </Col>
                  <Col sm={4} xs={12}>
                    <Nav.Item>
                      <Nav.Link eventKey="#decoration">
                        <div className="interior-services-icon">
                          <i className="pe-7s-shuffle"></i>
                        </div>
                        <h5 className="mb-0 text-uppercase f-15 letter-spacing_2 mt-3">
                          CORPORATE EVENT
                        </h5>
                      </Nav.Link>
                    </Nav.Item>
                  </Col>
                </Nav>
                <Tab.Content className="tab-content" id="pills-tabContent">
                  <Tab.Pane eventKey="#planning">
                    <div className="row mt-5 align-items-center">
                      <div className="col-lg-6">
                        <div className="interior-services-img mt-4">
                          <img
                            src={bg2}
                            className="img-fluid"
                            alt="Bride and groom using The Endless Moment digital guestbook"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="interior-services-info mt-4">
                          <p className="text-muted mt-4">
                            Make your wedding day even more memorable with our
                            easy-to-use digital photo and guestbook solution.
                            Simply scan a QR code to snap photos, leave
                            messages, and create a beautiful virtual guestbook
                            that you can cherish forever. No apps or downloads
                            needed—just scan and enjoy!
                          </p>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="#interior">
                    <div className="row mt-5 align-items-center">
                      <div className="col-lg-6">
                        <div className="interior-services-info mt-4">
                          <p className="text-muted mt-4">
                            Turn your party into an interactive experience! With
                            just a QR code scan, guests can take fun photos,
                            write messages, and instantly contribute to a
                            digital guestbook. Easy, engaging, and perfect for
                            any celebration—no setup or hassle required.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="interior-services-img mt-4">
                          <img
                            src={bg3}
                            className="img-fluid"
                            alt="The Endless Moment party guests using QR code booth"
                          />
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="#decoration">
                    <div className="row mt-5 align-items-center">
                      <div className="col-lg-6">
                        <div className="interior-services-img mt-4">
                          <img
                            src={bg4}
                            className="img-fluid"
                            alt="Corporate event attendees using The Endless Moment digital guestbook"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="interior-services-info mt-4">
                          <p className="text-muted mt-4">
                            Boost engagement at your next corporate event with
                            our simple QR code-based digital photo and guestbook
                            solution. Attendees can scan the code to capture
                            photos, share feedback, and leave messages—making it
                            easy to create a lasting digital record of your
                            event.
                          </p>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
      <hr />
      <section className="section photographer-pricing py-10" id="packages">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="text-center">
                <h2 className="heading-title-title letter-spacing_4 text-uppercase">
                  Our Packages
                </h2>
                <hr
                  style={{
                    width: "130px",
                    margin: "auto",
                    marginTop: "20px",
                    borderTop: "1px solid #533C2B",
                    opacity: 1,
                  }}
                />
                <p className="heading-title-desc text-muted mt-4">
                  Tailored Packages for Every Moment <br />
                  Explore our carefully curated packages designed to make your
                  event unforgettable.
                </p>

                <p className="heading-title-desc mt-4">
                  <b>
                    Curious to see how it works? Sign up for a free demo, no
                    commitment required.
                  </b>
                </p>
              </div>
            </Col>
          </Row>

          <div className="mt-5 pt-3">
            <div
              className="p-4 mb-4"
              style={{
                backgroundColor: "#F7F1EA",
                borderLeft: "4px solid #917054",
              }}
            >
              <Row className="align-items-center">
                <Col lg={8}>
                  <h4 className="heading-title-title mb-2">
                    One-Time Event Packages
                  </h4>
                  <p className="text-muted mb-0">
                    Designed for a single event, our Basic and Essential packages offer a one-time payment with no recurring fees.
                  </p>
                </Col>
              </Row>
            </div>

            <Row>
              {oneTimePlans.map((item: PricingData) => (
                <Col
                  lg={6}
                  key={item.id}
                  className="d-flex align-items-stretch mb-4"
                >
                  <div
                    className="photographer-pricing-box-active p-4 d-flex flex-column w-100"
                    style={{
                      borderTop: "3px solid #917054",
                      minHeight: "100%",
                    }}
                  >
                    <div className="text-center">
                      <p
                        className="text-uppercase f-13 letter-spacing_2 mb-2"
                        style={{ color: "#917054" }}
                      >
                        One-Time Payment
                      </p>
                      <h5 className="letter-spacing_4 text-uppercase f-18">
                        {item.name}
                      </h5>
                      <p className="f-14 text-muted mb-3">
                        {item.description}
                      </p>
                      <h1 className="m-0">
                        <span className="f-18">SGD $ </span>
                        {item.price}
                      </h1>
                    </div>

                    <hr
                      style={{
                        width: "90%",
                        margin: "24px auto",
                        borderTop: "1px solid #917054",
                        opacity: 1,
                      }}
                    />

                    <div className="photographer-pricing-plan flex-grow-1">
                      {item.features.map((feature, index) => (
                        <p className="pricing-plan" key={index}>
                          {getFeatureName(feature)}
                        </p>
                      ))}
                    </div>
                    <div className="mt-4 pt-3 text-center mt-auto">
                      <a
                        href={getPurchaseUrl()}
                        className="btn btn-md btn-custom"
                      >
                        Buy Package
                      </a>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>

            <div
              className="p-4 mt-4 mb-4"
              style={{
                backgroundColor: "#F0E5D6",
                borderLeft: "4px solid #533C2B",
              }}
            >
              <Row className="align-items-center">
                <Col lg={8}>
                  <h4 className="heading-title-title mb-2">
                    Corporate Subscription
                  </h4>
                  <p className="text-muted mb-0">
                   Ideal for event planners and businesses, offering recurring monthly access to create and manage digital guestbooks across multiple events.
                  </p>
                </Col>
              
              </Row>
            </div>

            <Row>
              {corporatePlans.map((item: PricingData) => (
                <Col
                  lg={6}
                  key={item.id}
                  className="d-flex align-items-stretch mb-4"
                >
                  <div
                    className="photographer-pricing-box-active p-4 d-flex flex-column w-100"
                    style={{
                      borderTop: "3px solid #533C2B",
                      minHeight: "100%",
                    }}
                  >
                    <div className="text-center">
                      <p
                        className="text-uppercase f-13 letter-spacing_2 mb-2"
                        style={{ color: "#917054" }}
                      >
                        Monthly Subscription
                      </p>
                      <h5 className="letter-spacing_4 text-uppercase f-18">
                        {item.name}
                      </h5>
                      <p className="f-14 text-muted mb-3">
                        {item.description}
                      </p>
                      <h1 className="m-0">
                        <span className="f-18">SGD $ </span>
                        {item.price}
                        <span className="f-15 text-muted"> / month</span>
                      </h1>
                    </div>

                    <hr
                      style={{
                        width: "90%",
                        margin: "24px auto",
                        borderTop: "1px solid #917054",
                        opacity: 1,
                      }}
                    />

                    <div className="photographer-pricing-plan flex-grow-1">
                      {item.features.map((feature, index) => (
                        <p className="pricing-plan" key={index}>
                          {getFeatureName(feature)}
                        </p>
                      ))}
                    </div>
                    <div className="mt-4 pt-3 text-center mt-auto">
                      <a
                        href={getPurchaseUrl()}
                        className="btn btn-md btn-custom"
                      >
                        Start Subscription
                      </a>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>

            <Row className="mt-4">
              <Col lg={12}>
                <div
                  className="p-4 text-center"
                  style={{
                    backgroundColor: "#F7F1EA",
                    border: "1px solid #E3D4C5",
                  }}
                >
                  <h4 className="heading-title-title mb-2">
                    Need more than 10 events?
                  </h4>
                  <p className="mb-0">
                    Get in touch with us at{" "}
                    <strong>enquiries@theendlessmoment.com</strong>
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <hr />
      <section className="section py-10" id="howto">
        <Container>
          <div className="text-center">
            <h2 className="heading-title-title letter-spacing_4 text-uppercase">
              How to Use
            </h2>
            <hr
              style={{
                width: "130px",
                margin: "auto",
                marginTop: "20px",
                borderTop: "1px solid #533C2B",
                opacity: 1,
              }}
            />
            <p className="heading-title-desc text-muted mt-4 ">
              Our digital photo and guestbook solution makes it simple to engage
              your guests and preserve memories at any event. From weddings to
              corporate events, just follow these 4 easy steps to create a
              personalized, interactive experience that you and your guests will
              treasure forever.​
            </p>
          </div>

          {/* BLOG */}
          <div>
            <Row className="mt-5 pt-1">
              <Col lg={1}>
                <div className="sidebar"></div>
              </Col>
              <Col lg={10}>
                <div className="business-blog-box mt-2">
                  <div className="business-blog-content-left bg-white p-3 d-flex flex-column-reverse flex-lg-row align-items-center">
                    <div className="business-blog-text">
                      <h5 className="f-22 line-height_1_6">
                        STEP 1<p className="f-22">Set Up Your Event</p>
                      </h5>
                      <p className="text-muted mt-3">
                        Customize your event layout, colors, and settings to
                        match your theme—quick, simple, and fun! Whether it’s a
                        wedding, birthday, or corporate event, you can make it
                        truly yours.
                        <br />
                        <br />
                        <i>
                          Think of it as your digital stage—everything looks
                          perfect before your guests even arrive.
                        </i>
                      </p>
                    </div>
                    <div className="business-blog-img mr-3">
                      <img src={step1} className="img-fluid" alt="" />
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={1}>
                <div className="sidebar"></div>
              </Col>
            </Row>
            <Row className="mt-5 pt-1">
              <Col lg={1}>
                <div className="sidebar"></div>
              </Col>
              <Col lg={10}>
                <div className="business-blog-box mt-2">
                  <div className="business-blog-content-right bg-white p-3 d-flex flex-column-reverse flex-lg-row align-items-center">
                    <div className="business-blog-img mr-3">
                      <img src={step2} alt="" />
                    </div>
                    <div className="business-blog-text">
                      <h5 className="f-22 line-height_1_6">
                        STEP 2<p className="f-22">Generate Your QR Code</p>
                      </h5>
                      <p className="text-muted mt-3">
                        Create your event QR code and print it on banners,
                        cards, or anywhere your guests can easily scan. Use our
                        stylish Canva template to make it eye-catching in
                        seconds.
                        <br />
                        <br />
                        <i>
                          Your guests will feel like VIPs just by scanning
                          it—instant access to share memories!
                        </i>
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={1}>
                <div className="sidebar"></div>
              </Col>
            </Row>
            <Row className="mt-5 pt-1">
              <Col lg={1}>
                <div className="sidebar"></div>
              </Col>
              <Col lg={10}>
                <div className="business-blog-box mt-2">
                  <div className="business-blog-content-left bg-white p-3 d-flex flex-column-reverse flex-lg-row align-items-center">
                    <div className="business-blog-text">
                      <h5 className="f-22 line-height_1_6">
                        STEP 3<p className="f-22">Guests Scan & Share</p>
                      </h5>
                      <p className="text-muted mt-3">
                        Let your guests join the fun! They can snap photos,
                        upload videos, and leave personal messages in your
                        digital guestbook—all in real-time.
                        <br />
                        <br />
                        <i>
                          Watch your event come alive with stories, laughter,
                          and memories from every angle—everyone’s a part of the
                          magic!
                        </i>
                      </p>
                    </div>
                    <div className="business-blog-img mr-3">
                      <img src={step3} alt="" />
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={1}>
                <div className="sidebar"></div>
              </Col>
            </Row>
            <Row className="mt-5 pt-1">
              <Col lg={1}>
                <div className="sidebar"></div>
              </Col>
              <Col lg={10}>
                <div className="business-blog-box mt-2">
                  <div className="business-blog-content-right bg-white p-3 d-flex flex-column-reverse flex-lg-row align-items-center">
                    <div className="business-blog-img mr-3">
                      <img src={step4} alt="" />
                    </div>
                    <div className="business-blog-text">
                      <h5 className="f-22 line-height_1_6">
                        STEP 4<p className="f-22">Download & Relive Memories</p>
                      </h5>
                      <p className="text-muted mt-3">
                        After the event, download every photo, video, and
                        heartfelt message. Keep them forever and relive the best
                        moments anytime.
                        <i>
                          Turn your digital guestbook into a treasure chest of
                          memories—ready to share, laugh, and look back on for
                          years to come.
                        </i>
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={1}>
                <div className="sidebar"></div>
              </Col>
            </Row>
          </div>


        </Container>
      </section>
      <hr />
      <section className="section py-10" id="aboutus">
        <Container>
          <div className="text-center">
            <h2 className="heading-title-title letter-spacing_4 text-uppercase">
              What is The Endless Moment about?
            </h2>
            <hr
              style={{
                width: "130px",
                margin: "auto",
                marginTop: "20px",
                borderTop: "1px solid #917054",
                opacity: 1,
              }}
            />
          </div>
          <div className="text-center mb-5 mt-5">
            <div className="d-flex justify-content-center mb-3">
              <Image
                alt="Skyler, founder of The Endless Moment"
                src={profileImage}
                roundedCircle
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover",
                }}
              />
            </div>
            <h4 className="mb-1" style={{ color: "#917054" }}>
              Skyler
            </h4>
            <p className="text-secondary">Founder</p>
          </div>

          <div
            className="mb-5"
            style={{ textAlign: "justify" }}
            dangerouslySetInnerHTML={{
              __html: companyData?.founder_profile || "",
            }}
          />
        </Container>
      </section>
      <section style={{ backgroundColor: "#F0E5D6" }}>
        <Container>
          <Row className="align-items-stretch py-5">
            <Col md={5} className="text-center mb-4 mb-md-0">
              <h3 className="mb-3">Mission</h3>
              <p>
                {companyData?.mission ||
                  "To create a meaningful and innovative platform that preserves cherished memories and fosters lasting connections through personalized digital guestbooks."}
              </p>
            </Col>

            <Col md={2} className="d-flex justify-content-center">
              <div
                className="d-none d-md-block"
                style={{
                  width: "1px",
                  backgroundColor: "#dee2e6",
                  margin: "0 auto",
                }}
              />
            </Col>

            <Col md={5} className="text-center">
              <h3 className="mb-3">Vision</h3>
              <p>
                {companyData?.vision ||
                  "To revolutionize the way people celebrate special occasions by offering a seamless and interactive digital experience.​"}
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section>
        <Container>
          <div className="text-center mt-5">
            <h2 className="heading-title-title letter-spacing_4 text-uppercase">
              PHILOSOPHY
            </h2>
            <hr
              style={{
                width: "130px",
                margin: "auto",
                marginTop: "20px",
                borderTop: "1px solid #533C2B",
                opacity: 1,
              }}
            />
          </div>
          <Row className="d-flex justify-content-center align-items-center mt-5">
            <Col md={5}>
              <div className="mb-5" style={{ textAlign: "justify" }}>
                <p className="mb-4">
                  {companyData?.philosophy ||
                    "At The Endless Moment, we believe that every moment is a story waiting to be told  and cherished. Our philosophy is rooted in the idea that memories are the threads that weave the fabric of our lives, connecting us to our past, present, and future. We strive to create a platform that not only captures these moments but also enhances the way we experience and share them."}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <hr />
      <section className="section py-10" id="contactus">
        <ContactUs />
      </section>
      <Modal
        show={showVideo}
        onHide={() => setShowVideo(false)}
        size="lg"
        centered
        className="video-modal"
      >
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>Watch How It Works</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="video-container">
            {showVideo && (
              <iframe
                src="https://www.youtube.com/embed/BCSmYFvIcZw?si=YP827yqNn6MC8PIs&autoplay=1"
                title="Watch How It Works"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default Section;
